import { Button } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { TooltipContainer } from '~/components/tooltip-container/TooltipContainer';

import { useScenarioStore } from '../../hooks/use-scenario-store/useScenarioStore';
import { FilterList } from '../filter-list/FilterList';
import { HorizonSelector } from '../horizon-selector/HorizonSelector';
import * as S from './ScenarioToolbar.styles';

export interface ScenarioToolbarProps {
  activeHorizon: string;
  entitiesTags: string[];
  hasData: boolean;
  horizonLabels: string[];
  onEditAssets?: () => void;
  filtersNamesList: string[];
  setActiveHorizon: (horizon: string) => void;
  isWidgetMode?: boolean;
}

export const ScenarioToolbar = ({
  activeHorizon,
  entitiesTags,
  hasData,
  horizonLabels,
  onEditAssets,
  filtersNamesList,
  setActiveHorizon,
  isWidgetMode = true,
}: ScenarioToolbarProps) => {
  const { t } = useTranslation(['scenario']);
  const { activeFilters, activeEntitiesTags } = useScenarioStore(state => ({
    ...state.filterGroups['COLUMN_FILTERS'],
    activeEntitiesTags: state.activeEntitiesTags,
  }));

  const showEditAssetsButton = onEditAssets && isWidgetMode;

  const assetsFoundLabel = isWidgetMode
    ? t('scenario:assetsFound', {
        count: entitiesTags.length,
      })
    : t('scenario:assetsSelected', {
        count: entitiesTags.length,
      });

  const activeHorizonIndex = horizonLabels.indexOf(activeHorizon);
  const setActiveHorizonIndex = (index: number) =>
    setActiveHorizon(horizonLabels[index]);
  return (
    <S.ScenarioToolbarRoot data-testid="scenario-toolbar">
      <S.AssetCounter>
        {!!activeFilters.length && (
          <S.RowCounterLabel>
            {t('scenario:rowsCount', { count: activeEntitiesTags?.length })}
          </S.RowCounterLabel>
        )}
        <TooltipContainer
          showUnderline={!!filtersNamesList.length}
          disabled={!filtersNamesList.length}
          label={
            <FilterList
              title={t('scenario:assetsFoundTooltip')}
              list={filtersNamesList}
            />
          }
        >
          <S.AssetCounterLabel>{assetsFoundLabel}</S.AssetCounterLabel>
        </TooltipContainer>
        {showEditAssetsButton && (
          <Button
            variant="empty"
            iconName="Edit"
            size="xsmall"
            onClick={onEditAssets}
          />
        )}
      </S.AssetCounter>

      {hasData && !!entitiesTags.length && (
        <HorizonSelector
          horizonLabels={horizonLabels}
          onClick={setActiveHorizonIndex}
          activeHorizonIndex={activeHorizonIndex}
        />
      )}
    </S.ScenarioToolbarRoot>
  );
};
